import { FETCH_HOLIDAYS_REQUEST, FETCH_HOLIDAYS_SUCCESS, FETCH_HOLIDAYS_FAILURE } from './actionTypes';

const initialState = {
  holidaysByYear: {},
  fetchingYears: {},
};

const holidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOLIDAYS_REQUEST:
      return {
        ...state,
        fetchingYears: { ...state.fetchingYears, [action.payload.year]: true },
      };
    case FETCH_HOLIDAYS_SUCCESS:
      return {
        ...state,
        holidaysByYear: {
          ...state.holidaysByYear,
          [action.payload.year]: action.payload.holidays,
        },
        fetchingYears: { ...state.fetchingYears, [action.payload.year]: false },
      };
    case FETCH_HOLIDAYS_FAILURE:
      return {
        ...state,
        fetchingYears: { ...state.fetchingYears, [action.payload.year]: false },
      };
    default:
      return state;
  }
};

export default holidaysReducer;
